import { render, staticRenderFns } from "./BlockLogin.vue?vue&type=template&id=677e66c5&scoped=true&"
import script from "./BlockLogin.vue?vue&type=script&lang=js&"
export * from "./BlockLogin.vue?vue&type=script&lang=js&"
import style0 from "./BlockLogin.vue?vue&type=style&index=0&id=677e66c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e66c5",
  null
  
)

export default component.exports